//@ts-nocheck
import { useRef, useState } from "react";
import { getAddressValue, sortAddress } from "../utils";

declare global {
  interface Window {
    google: any;
  }
}
export type LocationProps = {
  state?: string;
  region?: string;
  vicinity?: string;
  latitude?: number;
  longitute?: number;
  address?: string;
};
export const useMap = (
  initialState: LocationProps,
  onDragUpdate?: (l: any) => any,
) => {
  const [location, setLocation] = useState<LocationProps>(initialState);
  const node = useRef(null);
  const geocoder = useRef<window.google.maps.Geocoder | undefined>();
  const [state, setAppState] = useState<{
    geocodedAddress?: boolean;
    display_error?: boolean;
    customErrorMessage?: string;
  }>({});

  const setState = (_state: any) => {
    setAppState({ ...state, ..._state });
  };
  const onDragEnd = ({ latitude, longitude }) => {
    // this.setState(state=>({...state, latitude,longitude}))
    geocoder.current = new window.google.maps.Geocoder();
    geocoder.current?.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === "OK") {
          const r = updateStateAndVicinity(results[0], []);
          // if onDragUpdate is passed as a prop, send the location data to the parent component
          if (onDragUpdate) {
            onDragUpdate(r);
          }
        }
      },
    );
  };

  const geocodingAction = (address, onSuccess, onError = () => {}) => {
    if (!Boolean(geocoder.current)) {
      geocoder.current = new window.google.maps.Geocoder();
    }
    geocoder.current?.geocode({ address: address }, (results, status) => {
      if (status === "OK") {
        if (results.length > 0) {
          onSuccess(results);
        }
      }
      if (status === "ZERO_RESULTS") {
        onError();
      }
    });
  };

  const onUpdateMapPosition = (coordinate: { lat: number; lng: number }) => {
    setState({
      geocodedAddress: true,
      customErrorMessage: "",
    });
    node.current?.panTo(
      new window.google.maps.LatLng(coordinate.lat, coordinate.lng),
    );
  };
  const updateStateAndVicinity = (data) => {
    let address = data.name || getAddressValue(data.address_components);
    let components = sortAddress(data.address_components);
    let latitude = data.geometry.location.lat();
    let longitude = data.geometry.location.lng();
    const newLocation = { ...components, latitude, longitude, address };
    if (Object.keys(components).length > 0 && latitude && longitude) {
      setLocation(newLocation);
      setState({ geocodedAddress: true });
      node.current?.panTo(new window.google.maps.LatLng(latitude, longitude));
    }
    return newLocation;
  };
  const onMapMount = (e) => {
    node.current = e;
  };
  return {
    onDragEnd,
    location,
    onMapMount,
    geocodingAction,
    onUpdateMapPosition,
    setLocation,
    updateStateAndVicinity,
  };
};

export type FullGetMapProps = ReturnType<typeof useMap>;
export type GetUseMapProps = Omit<FullGetMapProps, "setLocation">;
